'use client';

import { useAuth } from '../contexts/AuthContext';
import Image from 'next/image';

interface AuthWrapperProps {
  children: React.ReactNode;
}

export function AuthWrapper({ children }: AuthWrapperProps) {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#feeaca' }}>
        <div className="relative flex flex-col items-center">
          {/* Branded loading spinner */}
          <div className="relative">
            <div className="w-24 h-24 rounded-full animate-spin" style={{
              background: `conic-gradient(from 0deg, #f2593d 0deg, #f2593d 90deg, transparent 90deg, transparent 360deg)`,
              padding: '4px'
            }}>
              <div className="w-full h-full rounded-full" style={{ backgroundColor: '#feeaca' }}></div>
            </div>

            {/* Logo in center */}
            <div className="absolute inset-0 flex items-center justify-center">
              <Image
                src="/brand/skill-bridger-mark.svg"
                alt="Skill Bridger Logo"
                width={48}
                height={48}
                className="w-12 h-12"
              />
            </div>
          </div>

          {/* Loading text */}
          <div className="mt-6 flex items-center space-x-1">
            <p style={{ color: '#f2593d' }} className="font-semibold text-lg">Loading</p>
            <div className="flex space-x-1">
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#f2593d', animationDelay: '0ms' }}></div>
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#f2593d', animationDelay: '150ms' }}></div>
              <div className="w-2 h-2 rounded-full animate-bounce" style={{ backgroundColor: '#f2593d', animationDelay: '300ms' }}></div>
            </div>
          </div>

          <p className="mt-2 text-gray-600 text-sm font-medium">Bridge your skills to success</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
